import { ArrowLeft, Settings, User, Wrench } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface RepairHeaderProps {
  productName: string;
  modelNumber: string;
  category: string;
}

export function RepairHeader({ productName, modelNumber, category }: RepairHeaderProps) {
  const navigate = useNavigate();
  const { t } = useTranslation('repair');

  return (
    <header className="flex items-center justify-between px-6 py-4 bg-card border-b border-border">
      <div className="flex items-center gap-6">
        <button
          onClick={() => navigate("/work-orders")}
          className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">{t('header.back')}</span>
        </button>

        <div className="flex items-center gap-2">
          <div>
            <h1 className="font-bold text-foreground">FixID</h1>
            <div className="flex items-center gap-1 text-sm text-muted-foreground">
              <Wrench className="w-3 h-3" />
              <span>{t('header.subtitle')}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-6">
        <div className="text-right">
          <p className="font-medium text-foreground">{productName}</p>
          <div className="flex items-center gap-2 justify-end">
            <span className="text-sm text-muted-foreground">{modelNumber}</span>
            <span className="category-badge category-badge-washing text-xs">{category}</span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button className="p-2 rounded-lg hover:bg-muted transition-colors">
            <Settings className="w-5 h-5 text-muted-foreground" />
          </button>
          <button className="p-2 rounded-lg hover:bg-muted transition-colors">
            <User className="w-5 h-5 text-muted-foreground" />
          </button>
        </div>
      </div>
    </header>
  );
}
